import { render, staticRenderFns } from "./orderSelect.vue?vue&type=template&id=16308b09&scoped=true"
import script from "./orderSelect.vue?vue&type=script&lang=js"
export * from "./orderSelect.vue?vue&type=script&lang=js"
import style0 from "./orderSelect.vue?vue&type=style&index=0&id=16308b09&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16308b09",
  null
  
)

export default component.exports